import request from "@/utils/request";
import baseUrl from "@/utils/base-url";
import axios from "axios";

export function verify(data) {
    return request({
        url: baseUrl.base+"/verify",
        method: "post",
        data: data
    });
}
export function checkSign(data, func) {
    axios.post(baseUrl.base + '/checkSign', data)
        .then(function(response) {
            func(response)
        })
        .catch(function(error) {
            console.log(error);
        });
}
